import * as React from 'react';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import AppAppBar from '../AppAppBar';
import Footer from '../Footer';

export default function Terms({ mode, toggleColorMode }) {
  return (
    <React.Fragment>
      <AppAppBar mode={mode} toggleColorMode={toggleColorMode} />
      <Container 
        component="main" 
        sx={{ 
          mt: { xs: 12, md: 14 }, 
          mb: { xs: 12, md: 14 },
          px: { xs: 2, sm: 3, md: 4 }
        }} 
        maxWidth="lg"
      >
        <Box>
          <Typography variant="h4" component="h1" gutterBottom>
            Nutzungsbedingungen
          </Typography>
          <Typography variant="body1" paragraph>
            Stand: November 2025
          </Typography>
          <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
            1. Geltungsbereich
          </Typography>
          <Typography variant="body1" paragraph>
            Diese Nutzungsbedingungen gelten für die Nutzung unserer Website und aller damit verbundenen Dienste.
          </Typography>
          <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
            2. Nutzungsrechte
          </Typography>
          <Typography variant="body1" paragraph>
            Mit der Nutzung unserer Website erkennen Sie die folgenden Bedingungen an. Die Nutzung der Website ist nur im Rahmen der geltenden gesetzlichen Bestimmungen erlaubt.
          </Typography>
          <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
            3. Haftungsausschluss
          </Typography>
          <Typography variant="body1" paragraph>
            Wir bemühen uns, die Inhalte unserer Website aktuell und korrekt zu halten, übernehmen jedoch keine Gewähr für die Richtigkeit, Vollständigkeit und Aktualität der bereitgestellten Informationen.
          </Typography>
          {/* Weitere Nutzungsbedingungen hier */}
        </Box>
      </Container>
      <Footer />
    </React.Fragment>
  );
}